module.exports = __webpack_public_path__ + "static/img/P5_gray.f48852e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medusa/P5_gray.png
// module id = PkYQ
// module chunks = 0